// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Grid,
  Modal,
  Typography,
  useMediaQuery,
} from "@mui/material";
import styles from "../positionManagement.module.css";

// utils
import theme from "../../../../theme";
import dayjs from "dayjs";
import {
  convertFromGivenTimezoneToUTC,
  convertFromUTCToGivenTimezone,
  getFormattedFullDate,
  getTSeparatedDate,
} from "../../../../utils/methods/dateAndTimeMethods";
import { CustomTimeInput } from "../../../../components/Custom/TimeInput";
import { apiRequest } from "../../../../services/apiService";
import { useDispatch } from "react-redux";
import { alertDialogAciton } from "../../../../store/actions/auth";
import LoadingOverlay from "../../../../components/Custom/LoadingOverlay";
import { CustomTextFiled } from "../../../../components/Custom/Input";
import { fetchSinglePositionDataAction } from "../../../../store/actions/contractorScheduleTabActions";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import { addEditLogAction } from "../../../../store/actions/logs";
import { useSelector } from "react-redux";
import { getUTCTimeDifference } from "../../../../utils/methods/timeDiff";
import { isClientAndConPosTermsDiffrent } from "../../../../appCalcutions";

export const PositionManagementTab = ({ data }) => {
  // initial data start...
  const changedFieldsInit = React.useMemo(() => {
    return {
      contractor_actualStart: false,
      contractor_firstBreak: false,
      contractor_afterFirstBreakIn: false,
      contractor_secondBreak: false,
      contractor_afterSecondBreakIn: false,
      contractor_actualEnd: false,
    };
  }, []);
  // initial data end...

  const [positionData, setPositionData] = React.useState({});
  const [oldData, setOldData] = React.useState({});
  const [isEditData, setIsEditData] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [showReasonModal, setShowReasonModal] = React.useState(false);
  const [reason, setReason] = React.useState("");
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.auth);
  const [aStart, setAStart] = React.useState(0);
  const [aEnd, setAEnd] = React.useState(1);
  const [changedFields, setChangedFields] = React.useState(changedFieldsInit);

  // NOTE: do the api call here to get the contractor time's input
  async function fetchContractorPositionData() {
    setIsLoading(true);
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getPositionContractorSide",
      params: {
        sessionId: data?.sessionId,
        id: data?.id,
      },
      isToken: true,
    });

    if (response?.status === 200) {
      setPositionData({
        ...response?.data?.data,
        contractorType: response?.data?.contractorType,
      });
      setOldData({
        contractor_actualStart: response?.data?.data?.actualStart || null,
        contractor_firstBreak: response?.data?.data?.firstBreak || null,
        contractor_afterFirstBreakIn:
          response?.data?.data?.afterFirstBreakIn || null,
        contractor_secondBreak: response?.data?.data?.secondBreak || null,
        contractor_afterSecondBreakIn:
          response?.data?.data?.afterSecondBreakIn || null,
        contractor_actualEnd: response?.data?.data?.actualEnd || null,
      });
      setIsLoading(false);
    } else if (response?.status !== 200 || error) {
      setIsLoading(false);
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: "Failed to fetch the position data",
        }),
      );
    }

    // NOTE: check if the data is already filled then put the setIsEditData to true
    // if (
    //   response?.data?.data?.contractor_actualStart ||
    //   response?.data?.data?.contractor_firstBreak ||
    //   response?.data?.data?.contractor_afterFirstBreakIn ||
    //   response?.data?.data?.contractor_secondBreak ||
    //   response?.data?.data?.contractor_afterSecondBreakIn ||
    //   response?.data?.data?.contractor_actualEnd
    // ) {
    //   setIsEditData(true);
    // }
  }

  const isUTC = (dateStr) => {
    if (dateStr === null) return false;
    return dateStr?.includes("Z");
  };

  const getDefaultValue = (dateStr) => {
    return dayjs(dayjs(dateStr).tz(data?.eventTimeZone));
    // return !dateStr
    //   ? dayjs(
    //       removeOnlyOffset(
    //         convertFromUTCToGivenTimezone({
    //           dateStr: dateStr || null,
    //           timezone: positionData?.eventTimezone,
    //         }),
    //       ),
    //     )
    //   : isUTC(dateStr)
    //     ? dayjs(
    //         removeOnlyOffset(
    //           convertFromUTCToGivenTimezone({
    //             dateStr: dateStr || null,
    //             timezone: positionData?.eventTimezone,
    //           }),
    //         ),
    //       )
    //     : dayjs(dateStr);
  };

  async function handleSaveEdits() {
    setIsLoading(true);
    // NOTE: do the api call here to save the edits
    let dataToSend = {
      id: data?.id,
      contractor_actualStart: convertFromGivenTimezoneToUTC({
        date: positionData?.contractor_actualStart,
        timezone: data?.eventTimeZone,
      }),
      contractor_firstBreak: convertFromGivenTimezoneToUTC({
        date: positionData?.contractor_firstBreak,
        timezone: data?.eventTimeZone,
      }),
      contractor_afterFirstBreakIn: convertFromGivenTimezoneToUTC({
        date: positionData?.contractor_afterFirstBreakIn,
        timezone: data?.eventTimeZone,
      }),
      contractor_secondBreak: convertFromGivenTimezoneToUTC({
        date: positionData?.contractor_secondBreak,
        timezone: data?.eventTimeZone,
      }),
      contractor_afterSecondBreakIn: convertFromGivenTimezoneToUTC({
        date: positionData?.contractor_afterSecondBreakIn,
        timezone: data?.eventTimeZone,
      }),
      contractor_actualEnd: convertFromGivenTimezoneToUTC({
        date: positionData?.contractor_actualEnd,
        timezone: data?.eventTimeZone,
      }),
    };

    dataToSend = {
      ...dataToSend,
      ...(dataToSend?.contractor_actualStart && {
        actualStart: dataToSend?.contractor_actualStart,
      }),
      ...(dataToSend?.contractor_firstBreak && {
        firstBreak: dataToSend?.contractor_firstBreak,
      }),
      ...(dataToSend?.contractor_afterFirstBreakIn && {
        afterFirstBreakIn: dataToSend?.contractor_afterFirstBreakIn,
      }),
      ...(dataToSend?.contractor_secondBreak && {
        secondBreak: dataToSend?.contractor_secondBreak,
      }),
      ...(dataToSend?.contractor_afterSecondBreakIn && {
        afterSecondBreakIn: dataToSend?.contractor_afterSecondBreakIn,
      }),
      ...(dataToSend?.contractor_actualEnd && {
        actualEnd: dataToSend?.contractor_actualEnd,
      }),
    };

    // if (isClientAndConPosTermsDiffrent({pos: dataToSend})) {
    //   dataToSend = {
    //     ...dataToSend,
    //   ...(dataToSend?.contractor_actualStart && {
    //     contractorActualStart: dataToSend?.contractor_actualStart,
    //   }),
    //   ...(dataToSend?.contractor_firstBreak && {
    //     contractorFirstBreak: dataToSend?.contractor_firstBreak,
    //   }),
    //   ...(dataToSend?.contractor_afterFirstBreakIn && {
    //     contractorAfterFirstBreakIn: dataToSend?.contractor_afterFirstBreakIn,
    //   }),
    //   ...(dataToSend?.contractor_secondBreak && {
    //     contractorSecondBreak: dataToSend?.contractor_secondBreak,
    //   }),
    //   ...(dataToSend?.contractor_afterSecondBreakIn && {
    //     contractorAfterSecondBreakIn: dataToSend?.contractor_afterSecondBreakIn,
    //   }),
    //   ...(dataToSend?.contractor_actualEnd && {
    //     contractorActualEnd: dataToSend?.contractor_actualEnd,
    //   }),
    //   }
    // }

    // NOTE: to add data for ot dt and mot

    let updatedValues = {};
    let initialValues = {};
    if (reason !== "") {
      dataToSend.reason = reason;
    }

    for (const key in oldData) {
      if (oldData[key] !== dataToSend[`contractor_${key}`]) {
        if (changedFields[key]) {
          updatedValues[key] = dataToSend[key];
        }
        initialValues[key] = oldData[key] || null;
      }
    }

    const { response, error } = await apiRequest({
      method: "PUT",
      url: `${isEditData ? "updatePositionContractorSide" : "addPositionContractorSide"}/${data?.sessionId}`,
      data: dataToSend,
      isToken: true,
    });

    if (response?.status === 200) {
      setIsLoading(false);
      setIsEditData(false);
      // NOTE: edit log
      dispatch(
        addEditLogAction({
          id: positionData?.eventId,
          payload: {
            actionById: userId,
            sessionId: data?.sessionId,
            positionId: positionData?.positionId,
            description: `${data?.positionName} position data has been updated`,
            previousValues: initialValues,
            updatedValues,
          },
          successCallback: () => {
            setChangedFields({ ...changedFieldsInit });
          },
        }),
      );
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: "Successfully saved the data",
        }),
      );
      dispatch(
        fetchSinglePositionDataAction({
          sessionId: data?.sessionId,
          id: data?.id,
        }),
      );
    } else if (response?.status !== 200 || error) {
      setIsLoading(false);
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: "Failed to save the data",
        }),
      );
    }
  }

  const getHourAndMins = (date, dateStart) => {
    const hour = date?.$H;
    const min = date?.$m;

    const dt = dateStart ? new Date(dateStart) : new Date();

    dt?.setHours(hour);
    dt?.setMinutes(min);

    const formattedDtStr = getTSeparatedDate(dt);

    return formattedDtStr;
  };

  React.useEffect(() => {
    fetchContractorPositionData();
  }, []);

  React.useEffect(() => {}, [positionData]);

  const getUTCTime = (time) => {
    if (!time?.includes("Z")) return time;
    return convertFromUTCToGivenTimezone({
      dateStr: time,
      timezone: data?.eventTimeZone,
    });
  };

  // const getTimeDifferenceForW2 = (cType, time1, time2) => {
  //   if (cType === "w2") {
  //     const time = getUTCTimeDifference(getUTCTime(time2), getUTCTime(time1));
  //     if (time >= 16) {
  //       dispatch(
  //         alertDialogAciton({
  //           open: true,
  //           title: "Alert",
  //           message:
  //             "For W2 contractors, the maximum shift duration is 16 hours.",
  //         }),
  //       );
  //       return false;
  //     }
  //     return true;
  //   }
  //   return true;
  // };

  const checkIfEdit = (fieldName) => {
    if (oldData?.[fieldName]) {
      setIsEditData(true);
    }
  };

  if (isLoading) {
    return <LoadingOverlay open={isLoading} />;
  }

  return (
    <Box>
      <Box
        sx={{
          margin: "1% auto",
          padding: "1%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: "100%",
          alignItems: "center",
          border: "1px solid rgba(255,255,255,0.4)",
          borderRadius: "5px",
          backgroundColor: "rgba(0,0,0,0.4)",
          "@media (max-width: 600px)": {
            marginTop: "1rem",
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "2rem",
            "@media (max-width: 600px)": {
              fontSize: "26px",
              textAlign: "center",
            },
          }}
        >
          {data?.positionName}{" "}
          {data?.positionOrder ? `- ${data?.positionOrder}` : ""}{" "}
          <span style={{ color: `${theme.palette.green.main}` }}>
            &#40;{data?.eventName}&#41;
          </span>
        </Typography>
        <Typography sx={{ fontSize: isSmallScreen ? "20px" : "1.25rem" }}>
          Client: <span>{data?.clientName}</span>
        </Typography>
        <Typography sx={{ fontSize: "1.25rem" }}>
          ShowPhaze Lead: <span>{data?.coordinatorName}</span>
        </Typography>
      </Box>
      <Box
        sx={{
          height: isSmallScreen ? "auto" : "48px",
          border: `1px solid ${getCssVariableHandler({ variableName: "--primary-pink-hex" })}`,
          borderRadius: "5px",
        }}
      >
        <Typography
          sx={{
            fontSize: isSmallScreen ? "20px" : "28px",
            textAlign: "center",
          }}
        >
          {data?.startDate && getFormattedFullDate(data?.startDate)}
          {"  "}
          {data?.timeIn && data?.timeIn == "TBD"
            ? "TBD"
            : dayjs(data?.timeIn).tz(data?.eventTimeZone).format("LT")}
          {" - "}
          {data?.timeOut && data?.timeOut == "TBD"
            ? "TBD"
            : dayjs(data?.timeOut).tz(data?.eventTimeZone).format("LT")}
        </Typography>
      </Box>

      <Grid container spacing={2} sx={{ marginTop: "1rem" }}>
        <Grid item xs={12} sm={6}>
          <Box className={styles["time-field-container"]}>
            <Typography
              color={theme.palette.green.main}
              className={styles["time-field"]}
            >
              Actual Start:
            </Typography>
            <CustomTimeInput
              key={aStart}
              className={styles["time-field-input"]}
              defaultValue={getDefaultValue(
                positionData?.contractor_actualStart ||
                  // oldData?.contractor_actualStart ||
                  null,
              )}
              onChange={(newValue) => {
                const convertedNewValue = getHourAndMins(
                  newValue,
                  data?.startDate,
                );
                // const newData = getTimeDifferenceForW2(
                //   positionData?.contractorType,
                //   positionData?.contractor_actualEnd,
                //   convertedNewValue,
                // );
                setPositionData({
                  ...positionData,
                  contractor_actualStart: convertedNewValue,
                });
                checkIfEdit("contractor_actualStart");
                setChangedFields((changedFields) => {
                  return {
                    ...changedFields,
                    contractor_actualStart: true,
                  };
                });
                // if (!newData) {
                //   setAStart(aStart + 1);
                // }
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box className={styles["time-field-container"]}>
            <Typography className={styles["time-field"]}>
              First Break:
            </Typography>
            <CustomTimeInput
              className={styles["time-field-input"]}
              defaultValue={getDefaultValue(
                positionData?.contractor_firstBreak ||
                  // oldData?.contractor_firstBreak ||
                  null,
              )}
              onChange={(newValue) => {
                setPositionData({
                  ...positionData,
                  contractor_firstBreak: getHourAndMins(
                    newValue,
                    data?.startDate,
                  ),
                });
                checkIfEdit("contractor_firstBreak");
                setChangedFields((changedFields) => {
                  return {
                    ...changedFields,
                    contractor_firstBreak: true,
                  };
                });
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box className={styles["time-field-container"]}>
            <Typography className={styles["time-field"]}>
              After First break In:
            </Typography>
            <CustomTimeInput
              className={styles["time-field-input"]}
              defaultValue={getDefaultValue(
                positionData?.contractor_afterFirstBreakIn ||
                  // oldData?.contractor_afterFirstBreakIn ||
                  null,
              )}
              onChange={(newValue) => {
                setPositionData({
                  ...positionData,
                  contractor_afterFirstBreakIn: getHourAndMins(
                    newValue,
                    data?.startDate,
                  ),
                });
                checkIfEdit("contractor_afterFirstBreakIn");
                setChangedFields((changedFields) => {
                  return {
                    ...changedFields,
                    contractor_afterFirstBreakIn: true,
                  };
                });
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box className={styles["time-field-container"]}>
            <Typography className={styles["time-field"]}>
              Second Break:
            </Typography>
            <CustomTimeInput
              className={styles["time-field-input"]}
              defaultValue={getDefaultValue(
                positionData?.contractor_secondBreak ||
                  // oldData?.contractor_secondBreak ||
                  null,
              )}
              onChange={(newValue) => {
                setPositionData({
                  ...positionData,
                  contractor_secondBreak: getHourAndMins(
                    newValue,
                    data?.startDate,
                  ),
                });
                checkIfEdit("contractor_secondBreak");
                setChangedFields((changedFields) => {
                  return {
                    ...changedFields,
                    contractor_secondBreak: true,
                  };
                });
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box className={styles["time-field-container"]}>
            <Typography className={styles["time-field"]}>
              After Second Break In:
            </Typography>
            <CustomTimeInput
              className={styles["time-field-input"]}
              defaultValue={getDefaultValue(
                positionData?.contractor_afterSecondBreakIn ||
                  // oldData?.contractor_afterSecondBreakIn ||
                  null,
              )}
              onChange={(newValue) => {
                setPositionData({
                  ...positionData,
                  contractor_afterSecondBreakIn: getHourAndMins(
                    newValue,
                    data?.startDate,
                  ),
                });
                checkIfEdit("contractor_afterSecondBreakIn");
                setChangedFields((changedFields) => {
                  return {
                    ...changedFields,
                    contractor_afterSecondBreakIn: true,
                  };
                });
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box className={styles["time-field-container"]}>
            <Typography
              color={theme.palette.green.main}
              className={styles["time-field"]}
            >
              Actual End:
            </Typography>
            <CustomTimeInput
              key={aEnd}
              className={styles["time-field-input"]}
              defaultValue={getDefaultValue(
                positionData?.contractor_actualEnd ||
                  // oldData?.contractor_actualEnd ||
                  null,
              )}
              onChange={(newValue) => {
                const convertedNewValue = getHourAndMins(
                  newValue,
                  data?.startDate,
                );
                // const newData = getTimeDifferenceForW2(
                //   positionData?.contractorType,
                //   convertedNewValue,
                //   positionData?.contractor_actualStart,
                // );
                setPositionData({
                  ...positionData,
                  contractor_actualEnd: convertedNewValue,
                });
                checkIfEdit("contractor_actualEnd");
                setChangedFields((changedFields) => {
                  return {
                    ...changedFields,
                    contractor_actualEnd: true,
                  };
                });
                // if (!newData) {
                //   setAEnd(aEnd + 1);
                // }
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Box
        className="bottomButton"
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "5rem",
          width: "100%",
        }}
      >
        <Button
          className="btnPink"
          onClick={() => {
            // NOTE: show the reason modal if the data is already filled
            if (isEditData && !showReasonModal) {
              setShowReasonModal(true);
              return;
            }
            handleSaveEdits();
          }}
        >
          <Typography className="btn-text">
            {isEditData ? "Save Edits" : " Save "}
          </Typography>
        </Button>
      </Box>

      <ReasonModal
        open={showReasonModal && isEditData}
        handleClose={() => {
          setShowReasonModal(false);
          setReason("");
        }}
        reasonValue={reason}
        handleChange={(e) => {
          setReason(e.target.value);
        }}
        handleSaveEdits={handleSaveEdits}
      />
    </Box>
  );
};

export const ReasonModal = ({
  title,
  open,
  handleClose,
  reasonValue,
  handleChange,
  handleSaveEdits,
}) => {
  const [error, setError] = React.useState(false);
  const [type, setType] = React.useState({
    hasReason: false,
    reason: "",
  });

  React.useEffect(() => {
    if (reasonValue?.length > 200) {
      setError(true);
      setType({
        hasReason: true,
        reason:
          "Reason is too long, please shorten it to 200 characters or less.",
      });
      return;
    }
    if (reasonValue !== "") {
      setError(false);
      setType({
        hasReason: false,
        reason: "",
      });
      return;
    }
    if (!error) return;
    const timeOut = setTimeout(() => {
      if (reasonValue !== "") {
        setError(false);
        setType({
          hasReason: false,
          reason: "",
        });
      }
    }, 5000);

    return () => {
      clearTimeout(timeOut);
    };
  }, [reasonValue, error]);

  const handleSave = () => {
    if (reasonValue === "") {
      setError(true);
      return;
    }
    if (reasonValue?.length > 200) {
      setError(true);
      setType({
        hasReason: true,
        reason:
          "Reason is too long, please shorten it to 200 characters or less.",
      });
      return;
    }
    handleClose();
    handleSaveEdits();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="reason modal"
      aria-describedby="modal for putting the reason"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          padding: 4,
          width: "40%",
          backgroundColor: "#000",
          zIndex: 9 + 10,
          borderRadius: "16px",
          border: "2px solid #D175B6",
          "@media (max-width: 600px)": {
            width: "96%",
            minWidth: "0",
          },
        }}
      >
        <Box className={styles["reason-modal"]}>
          <Typography className={styles["title"]}>
            {title || " Reason for the changes "}
          </Typography>
          <CustomTextFiled
            fullWidth
            name="reason"
            onChange={handleChange}
            value={reasonValue}
            multiline
            rows={4}
            placeholder="State your reason here, within 200 characters"
          />
          {error && (
            <Typography
              sx={{
                color: "red",
                fontSize: "1rem",
                textAlign: "center",
                transform: "translateY(60px)",
              }}
            >
              {type?.hasReason ? type?.reason : "Reason is required"}
            </Typography>
          )}
        </Box>
        <Box
          className="bottomButton"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "7rem",
            width: "100%",
          }}
        >
          <Button className="btnPink" onClick={handleSave}>
            <Typography className="btn-text">Save Edits</Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

PositionManagementTab.propTypes = {
  data: PropTypes.object,
};

ReasonModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  handleClose: PropTypes.func,
  reasonValue: PropTypes.string,
  handleChange: PropTypes.func,
  handleSaveEdits: PropTypes.func,
};